import { Button } from '@zep-us/zus';

/**
 * 공개 폴더 안의 퀴즈를 숨기려 할 때 뜨는 안내 (Figma 40295:27810).
 *
 * 공개 폴더에는 공개 퀴즈만 담긴다. 그래서 **저장 시점에 되묻지 않고** 숨기기 토글을 미리 막은 뒤,
 * 갈 수 있는 두 곳(비공개 폴더 · 내 퀴즈)을 여기서 바로 고르게 한다. 옮기고 나면 이 안내가 사라지고
 * 토글이 열린다 — 비공개 전환 자체는 사용자가 다시 누른다.
 *
 * ⚠️ 문구는 아직 **하드코딩**이다. 번역 시트 등록 후 `build` 네임스페이스의
 * `hideFromExplore.publicFolderNotice` · `.selectFolderAction` · `.moveToMyQuizAction` 로 옮긴다.
 */
export const PublicFolderMoveNotice = ({
  onSelectFolder,
  onMoveToMyQuiz,
  isMoving
}: {
  onSelectFolder: () => void;
  onMoveToMyQuiz: () => void;
  isMoving: boolean;
}) => <div className="flex w-full flex-col items-stretch gap-xs rounded-sm bg-neutral p-sm mobile-lg:flex-row mobile-lg:items-center" data-sentry-component="PublicFolderMoveNotice" data-sentry-source-file="PublicFolderMoveNotice.tsx">
    <p className="min-w-0 flex-1 text-body-sm-medium text-neutral">
      공개 폴더에 있는 퀴즈예요. 자료실에서 숨기기 전에 퀴즈 위치를 옮겨주세요.
    </p>
    <div className="flex shrink-0 gap-xs">
      <Button type="button" size="xs" variant="outlined" intent="neutral" disabled={isMoving} onClick={onSelectFolder} className="flex-1 whitespace-nowrap mobile-lg:flex-none" data-sentry-element="Button" data-sentry-source-file="PublicFolderMoveNotice.tsx">
        폴더 선택
      </Button>
      <Button type="button" size="xs" variant="outlined" intent="alternative" disabled={isMoving} onClick={onMoveToMyQuiz} className="flex-1 whitespace-nowrap mobile-lg:flex-none" data-sentry-element="Button" data-sentry-source-file="PublicFolderMoveNotice.tsx">
        내 퀴즈로 이동
      </Button>
    </div>
  </div>;